import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BackgroundImage from '@deliveroo/consumer-component-library/components/BackgroundImage';
import i18n from '../../utils/i18n';

import styles from './styles.scss';

export default class HomepageFeaturedCollectionTile extends Component {
  onClick = (event) => {
    event.preventDefault();
    this.props.onClick({
      name: this.props.name,
      id: this.props.id,
    });
  };

  render() {
    const { id, name, width, image, description } = this.props;

    return (
      <a
        key={id}
        data-name={name}
        className={styles.tile}
        onClick={this.onClick}
        style={{ width }}
        href="#top"
      >
        <div className={styles.hero}>
          <BackgroundImage src={image}>
            <div className={styles.heroContent}>
              <span className={styles.name}>{name}</span>
            </div>
          </BackgroundImage>
        </div>
        <div className={styles.description}>
          {description}
          <span className={styles.link}>
            {i18n.gettext('View %(collectionName)s →', { collectionName: name })}
          </span>
        </div>
      </a>
    );
  }
}

HomepageFeaturedCollectionTile.defaultProps = {
  description: null,
  image: null,
};

HomepageFeaturedCollectionTile.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired,
  description: PropTypes.string,
  image: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};
